import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import eco from "../catalogs/solidana_eco.pdf"
import ProductTable from "../components/product_table"

const ProductPage = () => {
  const widths = {
    sm: "82%",
  }
  return (
    <Layout inView={true}>
      <Seo title="Product" />
      <section>
        <div className="container max-w-7xl mx-auto flex flex-col items-center justify-center px-5 pt-32">
          <div className="w-full flex pb-24 md:flex-row flex-col items-center justify-center">
            <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
              <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-blue-800 font-bold">
                SOLIDANA ECO
              </h1>
              <p className="mb-1 leading-relaxed max-w-2xl">
                ECO proves itself as one of the most cost-effective tires in its
                class. It is a two-stage tire that has good tensile strength and
                provides a firm but smooth ride. Our creel bead technology
                ensures secure and safe fitment to all forklift wheels and rims.
                ECO is excellent for light and intermittent use in all material
                handling applications.
              </p>
              <div className="w-full flex flex-col max-w-md">
                <h2 className="title-font sm:text-2xl text-xl mb-3 mt-6 font-medium text-blue-800 font-semibold">
                  Performance
                </h2>
                <div className="relative pt-1 w-full">
                  <p className="font-medium mb-1">Energy Saving</p>
                  <div className="overflow-hidden h-3 mb-4 text-xs flex rounded bg-blue-200 w-full">
                    <div
                      style={{ width: widths.sm }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
                    ></div>
                  </div>
                </div>
                <div className="relative pt-1 w-full">
                  <p className="font-medium mb-1">Tire Life</p>
                  <div className="overflow-hidden h-3 mb-4 text-xs flex rounded bg-blue-200 w-full">
                    <div
                      style={{ width: widths.sm }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
                    ></div>
                  </div>
                </div>
                <div className="relative pt-1 w-full">
                  <p className="font-medium mb-1">Comfort</p>
                  <div className="overflow-hidden h-3 mb-4 text-xs flex rounded bg-blue-200 w-full">
                    <div
                      style={{ width: widths.sm }}
                      className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full max-w-xs lg:max-w-xs mx-auto">
              <StaticImage
                className="object-cover object-center max-w-xs w-full h-full mx-auto"
                alt="Material Handling Tire"
                src="../images/product_img.png"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-section">
        <div className="container max-w-7xl mx-auto flex flex-col items-center justify-center px-5 pt-28">
          <div className="w-full flex pb-24 md:flex-row flex-col-reverse items-center justify-center">
            <div className="w-full max-w-xs lg:max-w-md mx-auto">
              <StaticImage
                className="object-cover object-center max-w-xs w-full h-full mx-auto"
                alt="Material Handling Tire"
                src="../images/product_img2.png"
              />
            </div>
            <div className="lg:flex-grow md:w-1/2 md:pr-5 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
              <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-blue-800 font-bold">
                Features & Benefits
              </h1>
              <p className="mb-1 leading-relaxed max-w-2xl">
                Square footprint and increased lug depth. Optimized aspect
                ratio, even wearand increased stability. Lowrolling resistance,
                high abrasion resistance tread. Good mileage, optimized
                performance at lowercost. Moderate driving comfort due to
                optimum suspension & absorption. Low energy consumption and
                reduced co2 emissions.
              </p>
              <a
                href={eco}
                className="py-3 px-5 mt-6 text-white transition-colors duration-150 bg-blue-700 rounded-md focus:shadow-outline hover:bg-blue-800"
              >
                View Catalog
              </a>
            </div>
          </div>
          <ProductTable />
        </div>
      </section>
    </Layout>
  )
}
export default ProductPage
